// Key for storing filing instructions preferences
const STORAGE_KEY = 'filingInstructionsPreferences';

export const filingInstructionsStorage = {
  /**
   * Get all filing instructions preferences
   */
  getPreferences() {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored ? JSON.parse(stored) : this.getDefaults();
    } catch (error) {
      console.error('Error reading filing instructions preferences:', error);
      return this.getDefaults();
    }
  },

  /**
   * Get default preferences
   */
  getDefaults() {
    return {
      position: 'bottom', // 'bottom', 'left', 'right', or 'popup'
      visible: false,
      panelSize: {
        bottom: 300, // height in pixels
        left: 400, // width in pixels
        right: 400, // width in pixels
      },
    };
  },

  /**
   * Save position preference
   */
  savePosition(position) {
    try {
      const preferences = this.getPreferences();
      preferences.position = position;
      localStorage.setItem(STORAGE_KEY, JSON.stringify(preferences));
    } catch (error) {
      console.error('Error saving filing instructions position:', error);
    }
  },

  /**
   * Save panel size for a specific position
   */
  savePanelSize(position, size) {
    try {
      const preferences = this.getPreferences();
      if (!preferences.panelSize) {
        preferences.panelSize = {};
      }
      preferences.panelSize[position] = size;
      localStorage.setItem(STORAGE_KEY, JSON.stringify(preferences));
    } catch (error) {
      console.error('Error saving filing instructions panel size:', error);
    }
  },

  /**
   * Get saved panel size for a position
   */
  getPanelSize(position) {
    const preferences = this.getPreferences();
    const defaults = this.getDefaults();
    return (
      (preferences.panelSize && preferences.panelSize[position]) ||
      defaults.panelSize[position]
    );
  },

  /**
   * Get saved position
   */
  getPosition() {
    const position = this.getPreferences().position;
    return position || this.getDefaults().position;
  },

  /**
   * Save visibility preference
   */
  saveVisibility(visible) {
    try {
      const preferences = this.getPreferences();
      preferences.visible = visible;
      localStorage.setItem(STORAGE_KEY, JSON.stringify(preferences));
    } catch (error) {
      console.error('Error saving filing instructions visibility:', error);
    }
  },

  /**
   * Get saved visibility
   */
  getVisibility() {
    return this.getPreferences().visible;
  },

  /**
   * Clear all preferences
   */
  clearPreferences() {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      console.error('Error clearing filing instructions preferences:', error);
    }
  },
};
